import "./RfiReviewResponseComponent.less";
import * as React from "react";
import { LocalizeContextProps, withLocalize } from "react-localize-redux";
import { Log, Logger } from "../../../services/Logger";
import SuggestedProjectPickerComponent, {
    ProjectITag,
} from "../../shared/suggestedProjectPicker/SuggestedProjectPickerComponent";
import {
    DefaultButton,
    IComboBoxOption,
    IPersonaProps,
    ISuggestionItemProps,
    Label,
    ProgressIndicator,
    Separator,
    Stack,
    TagPicker,
    TextField,
} from "office-ui-fabric-react";
import { NewformaToastIntent } from "../../_base/Toast";
import FromAndToComponent from "../../shared/fromAndToComponent/FromAndToComponent";
import AttachmentsComponent from "../../shared/attachments/AttachmentsComponent";
import { MailboxItem, OfficeWrapper } from "../../../services/OfficeWrapper";
import { SmartFilingManager } from "../../../services/SmartFiling/SmartFilingManager";
import { FormValidationHelpers } from "../../../helpers/FormValidationHelpers";
import { AppPage } from "../../shared/navigationHeader/NavigationHeaderComponent";
import { ExpiredSessionError } from "../../../models/ExpiredSessionError";
import SuggestedItemWithSubtextComponent from "../../shared/pickerSuggestedItems/suggestedItemWithSubtext/SuggestedItemWithSubtextComponent";
import { IProjectsService } from "../../../services/NewformaApi/IProjectsService";
import { RfiApiService } from "../../../services/NewformaApi/RfiApiService";
import { ApiRequestErrorLevel } from "../../../models/ApiRequestErrorWithMessage";
import { RfiReviewResponseRequestParams } from "../../../models/workflow/rfi/RfiReviewResponseRequestParams";
import { WorkflowActionType } from "../../../models/workflow/WorkflowActionType";
import LabelComponent from "../../shared/label/LabelComponent";
import { AnalyticsManager } from "../../../services/AnalyticsManager";
import KeywordsDropdown from "../../shared/keywordsDropdown/KeywordsDropdown";
import { DetailedKeyword, KeywordListType } from "../../../models/ProjectKeywordsResponse";
import { MsGraphApiService } from "../../../services/MsGraphApiService";
import { NrnServiceWrapper } from "../../../services/NrnServiceWrapper";
import TranslatedDatePickerComponent from "../../shared/translatedDatePicker/TranslatedDatePickerComponent";
import ChipPickerComponent from "../../shared/chipPicker/ChipPickerComponent";
import { DateHelper, DateHelpers } from "../../../helpers/DateHelpers";
import { ProjectHelper } from "../../../helpers/ProjectHelper";
import { ProjectsCacheKeys } from "../../../models/StorageKeys";
import { InvalidateCacheService } from "../../../services/NewformaApi/InvalidateCacheService";
import { AttachmentItem } from "../../../models/shared/AttachmentList";
import HTMLEditor from "../../shared/editor/Editor";
import { ConfigurationService } from "../../../services/ConfigurationService";
import { AttachmentDataHelpers } from "../../../helpers/AttachmentDataHelpers";
import ForwardCheckbox from "../../shared/checkbox/forwardCheckbox";
import RespondCloseRfi from "../responseCloseRfi/respondCloseRfi";
import { ITagWithNixEnabled } from "../../../models/shared/ITagWithNixEnabed";
import { EmailRecipients } from "../../../models/shared/FileTransferEmailFieldsDetails";
import { RespondCloseRfiRequest } from "../../../models/workflow/rfi/RespondCloseRfiRequest";
import { OutlookApiService } from "../../../services/OutlookApiService";
import { isIPhone } from "../../../helpers/UtilityHelper";

export interface RfiReviewResponseComponentProps extends LocalizeContextProps {
    logger: Logger;
    onExpiredSession: () => void;
    onSetNavigationPage: (page: AppPage) => void;
    onShowToast: (message: string | null, type: NewformaToastIntent) => void;
    smartFilingManager: SmartFilingManager;
    officeWrapper: OfficeWrapper;
    formValidationHelpers: FormValidationHelpers;
    rfiApiService: RfiApiService;
    projectsService: IProjectsService;
    mailboxItem: MailboxItem | null;
    analyticsManager: AnalyticsManager;
    nrnServiceWrapper: NrnServiceWrapper;
    msGraphApiService: MsGraphApiService;
    dateHelpers: DateHelpers;
    invalidateCacheService: InvalidateCacheService;
    isFilePathInAttachmentsSupported?: boolean;
    isNL1221Supported: boolean;
    configService: ConfigurationService;
    isRfiRespondCloseSupported: boolean;
    showRespondAndCloseRfiTeachingBubble: boolean;
    onDismissTeachingBubble: () => void;
    culture: string;
    outlookApiService: OutlookApiService;
}

export interface RfiReviewResponseComponentState {
    isLoadingProjects: boolean;
    isLoadingKeywords: boolean;
    isCloudProject: boolean;
    projects: ITagWithNixEnabled[];
    selectedProject: ITagWithNixEnabled | null;
    isFiling: boolean;
    fileUploadIsInProgress: boolean;
    rfis?: ITagWithNixEnabled[];
    selectedRfi: ITagWithNixEnabled | undefined;
    actionKeywords: DetailedKeyword[];
    selectedActionKeyword: DetailedKeyword | null;
    response: string;
    attachments: AttachmentItem[];
    from: IPersonaProps[];
    to: IPersonaProps[];
    cc: IPersonaProps[];
    failedUploadAttachmentNames: string[];
    subject: string;
    receivedDate: Date | undefined;
    keywords: IPersonaProps[];
    selectedKeywords: IPersonaProps[];
    allowCustomKeywords: boolean;
    remarks: string;
    areToAndCCSame: boolean;
    shouldRespondAndClose: boolean;
    shouldShowRespondCloseOptions?: boolean;
    isRespondCloseFormValid: boolean;
    respondAndCloseDate: Date | undefined;
    respondAndCloseSelectedKeywords: IPersonaProps[];
    respondAndCloseKeywords: IPersonaProps[];
    respondAndCloseResponse: string | undefined;
    respondAndCloseEmailRecipients: EmailRecipients;
    isLoadingRecipientEmail: boolean;
    shouldClearRespondAndCloseValues: boolean;
    isLoadingPurposes: boolean;
    isLoadingRfis?: boolean;
    respondAndCloseBackButtonClicked: false;
    emailRecipients: EmailRecipients;
    respondAndCloseAttachments: AttachmentItem[];
    selectedAction: string | number | undefined;
    shouldDismissAttachmentErrors: boolean;
    projectsWithSuggestedToBeRendered: ProjectITag[];
}

export const rfiReviewResponseComponentDefaultState: RfiReviewResponseComponentState = {
    isLoadingProjects: true,
    isLoadingKeywords: false,
    isCloudProject: false,
    projects: [],
    selectedProject: null,
    isFiling: false,
    fileUploadIsInProgress: false,
    rfis: [],
    selectedRfi: undefined,
    actionKeywords: [],
    selectedActionKeyword: null,
    response: "",
    attachments: [],
    from: [],
    to: [],
    cc: [],
    failedUploadAttachmentNames: [],
    subject: "",
    receivedDate: undefined,
    keywords: [],
    selectedKeywords: [],
    allowCustomKeywords: false,
    remarks: "",
    areToAndCCSame: false,
    shouldRespondAndClose: false,
    shouldShowRespondCloseOptions: false,
    isRespondCloseFormValid: false,
    respondAndCloseDate: DateHelper.TodayDate,
    respondAndCloseSelectedKeywords: [],
    respondAndCloseKeywords: [],
    respondAndCloseResponse: "",
    respondAndCloseEmailRecipients: {
        to: [],
        cc: [],
    },
    isLoadingRecipientEmail: false,
    shouldClearRespondAndCloseValues: false,
    isLoadingPurposes: false,
    respondAndCloseBackButtonClicked: false,
    emailRecipients: {
        to: [],
        cc: [],
    },
    respondAndCloseAttachments: [],
    selectedAction: 0,
    shouldDismissAttachmentErrors: false,
    projectsWithSuggestedToBeRendered: [],
};

class RfiReviewResponseComponent extends React.Component<
    RfiReviewResponseComponentProps,
    RfiReviewResponseComponentState
> {
    _rfisCount: any = "";

    constructor(props: RfiReviewResponseComponentProps, context: RfiReviewResponseComponentState) {
        super(props, context);

        this.state = rfiReviewResponseComponentDefaultState;
    }

    async componentDidMount() {
        document.querySelector(".rfiReviewResponseComponent")?.scrollTo({
            top: 0,
            behavior: "auto",
        });
        this.props.logger.info("File Email as RFI Review Response component mounted");
        this.props.onSetNavigationPage(AppPage.FileAsRfiReviewResponse);
        await Promise.all([this.populateDefaults(), this.loadProjects()]);
    }

    async componentDidUpdate(
        prevProps: Readonly<RfiReviewResponseComponentProps>,
        prevState: Readonly<RfiReviewResponseComponentState>,
        snapshot?: any
    ) {
        if (prevProps === this.props) {
            return;
        }
        if (this.props.mailboxItem && prevProps.mailboxItem !== this.props.mailboxItem) {
            this.setState((state) => ({
                ...rfiReviewResponseComponentDefaultState,
                projects: state.projects,
                selectedProject: state.selectedProject,
                from: state.from,
                to: state.to,
                cc: state.cc,
            }));

            if (this.state.shouldShowRespondCloseOptions) {
                await this.loadProjects();
            }
            await this.populateDefaults();
            this.setState({ isLoadingProjects: false });
        }
        if (
            !this.state.shouldShowRespondCloseOptions &&
            this.state.shouldShowRespondCloseOptions !== prevState.shouldShowRespondCloseOptions
        ) {
            this.setState({ respondAndCloseBackButtonClicked: false });
        }
    }

    private async populateDefaults(): Promise<void> {
        const { inlineAttachments, attachmentsNoCloud } = AttachmentDataHelpers.partitionAttachments(
            this.props.officeWrapper.getCurrentEmailAttachmentDetails()
        );

        const subject = await this.props.officeWrapper.getCurrentEmailSubject();
        const receivedDate = this.props.officeWrapper.getCurrentEmailDate();

        this.setState({
            attachments: attachmentsNoCloud,
            subject: subject.trim(),
            receivedDate,
        });

        const remarks = await AttachmentDataHelpers.getHtmlBodyWithInlineAttachments(
            this.props.msGraphApiService,
            this.props.outlookApiService,
            this.props.isNL1221Supported,
            inlineAttachments
        );
        this.setState({ remarks });
    }

    private async loadProjects(): Promise<void> {
        this.setState({ isLoadingProjects: true });
        try {
            const projectsResponse = await this.props.projectsService.getProjectsSupportingRfis();
            const projectsITag: ITagWithNixEnabled[] = projectsResponse.projects.map((project) => {
                const projectDisplay = project.number ? `${project.number} - ${project.name}` : project.name;
                return { key: project.nrn, name: projectDisplay, nixEnabled: project.nixEnabled };
            });
            this.setState({ projects: projectsITag });
        } catch (error) {
            this.props.logger.error("RfiReviewResponseComponent - load projects error", error);

            if (ExpiredSessionError.isInstanceOf(error)) {
                this.props.onExpiredSession();
                return;
            }

            this.props.onShowToast(this.props.translate("SHARED.ERRORS.LOADING_PROJECTS_GENERIC") as string, "error");
        } finally {
            this.setState({ isLoadingProjects: false });
        }
    }

    private async onProjectSelected(selectedProject: ITagWithNixEnabled | null): Promise<void> {
        if (this.state.respondAndCloseBackButtonClicked && !this.state.shouldShowRespondCloseOptions) {
            return;
        }

        this.clearKeywords();
        const isCloudProject = this.props.nrnServiceWrapper.isCloudProject(selectedProject?.key as string);
        this.setState({ selectedProject, isCloudProject, shouldRespondAndClose: false });

        if (selectedProject) {
            this.setState({ isLoadingKeywords: true });
            await Promise.all([this.loadKeywords(selectedProject, isCloudProject), this.loadRfis(selectedProject)]);
            this.setState({ isLoadingKeywords: false });
        } else {
            this.setState({ respondAndCloseAttachments: [] });
            return;
        }
    }

    private clearKeywords(): void {
        this.setState({
            selectedActionKeyword: null,
            actionKeywords: [],
            selectedKeywords: [],
            keywords: [],
            selectedRfi: undefined,
            rfis: [],
        });
    }

    updateRfis(value: any) {
        Log.info(`Callback ${value} ${this.state.isLoadingRfis ?? ""}`);
        this._rfisCount = value;
    }

    _currentId = 0;

    getNewId(): number {
        this._currentId++;
        return this._currentId;
    }

    private async loadRfis(project: ITagWithNixEnabled): Promise<void> {
        const rfiService = this.props.rfiApiService;
        try {
            this.setState({ isLoadingRfis: true });
            rfiService.doAbort();

            let rfis = rfiService.loadCacheRfis(project.name);
            const curId = this.getNewId();

            if (!rfis || rfis.length === 0) {
                const abortCount = rfiService.AbortCount;

                const rfiResponse = await rfiService.getForwardedRfis(
                    project.key,
                    this.updateRfis.bind(this) // optional callback if needed like rfis
                );

                if (rfiService.AbortCount === abortCount) {
                    rfis = rfiResponse.map((rfi: any) => ({
                        name: rfi.number,
                        key: rfi.nrn,
                        description: rfi.subject,
                    }));

                    rfiService.saveCacheRfis(project.name, rfis);
                } else {
                    this.props.logger.info("Abort in LoadRfis");
                }
            }

            this.props.logger.info(`loadRfis ${rfis?.length}`);

            // inflight check like in submittals
            if (curId === this._currentId) {
                this.props.logger.info(`Accepting: ${curId}`);
                this.setState({ rfis }, () => {
                    this.setState({ isLoadingRfis: false });
                });
            } else {
                this.props.logger.info(`Rejecting: ${curId} vs ${this._currentId}`);
            }
        } catch (error) {
            this.props.logger.error("RfiReviewResponseComponent - load RFIs error", error);

            if (ExpiredSessionError.isInstanceOf(error)) {
                this.props.onExpiredSession();
                return;
            }

            const errorMessage =
                (error as any).status === 405
                    ? this.props.translate("RFI.ACTIVITY_CENTER_DISABLED_ERROR")
                    : this.props.translate("RFI.RESPONSE.FAILED_LOADING_RFIS");

            this.props.onShowToast(errorMessage as string, "error");
        } finally {
            this.setState({ isLoadingRfis: false });
        }
    }

    clearCache() {
        this.props.rfiApiService?.clearCache(); // the memory cache gets synched with external LS cache.
        this._rfisCount = undefined;
        this.setState({ rfis: [] });
    }

    handleMouseDownRfis(event: any) {
        if (event.ctrlKey) {
            this.clearCache();
            if (this.state.selectedProject) {
                this.loadRfis(this.state.selectedProject)
                    .then((result) => {
                        // Handle the resolved value here
                        Log.infoStyle("Reload: Rfis Completed", "green");
                    })
                    .catch((error) => {
                        // Handle errors here
                        Log.infoStyle("Reload Rfis Failed", "red");
                    });
            }
        }
    }

    private async loadKeywords(project: ITagWithNixEnabled, isCloudProject: boolean): Promise<void> {
        const actionType = isCloudProject ? WorkflowActionType.ReviewResponse : WorkflowActionType.ReviewResponseNpc;
        try {
            const workflowActionKeywordsResponse = await this.props.rfiApiService.getRfiActionKeywords(
                project.key,
                actionType
            );
            const sortedWorkflowActionKeywords = ProjectHelper.sortKeywords(workflowActionKeywordsResponse);
            const actionSortedKeywords: DetailedKeyword[] = sortedWorkflowActionKeywords.map((keyword, key) => ({
                displayOrder: key,
                name: keyword.name,
                type: keyword.type,
            }));
            this.setState({ actionKeywords: actionSortedKeywords });

            if (!isCloudProject) {
                const npcKeywordsResponse = await this.props.projectsService.getProjectKeywords(
                    project.key,
                    KeywordListType.RfiKeywords
                );
                const sortedKeywords = ProjectHelper.sortKeywords(npcKeywordsResponse);
                const keywords: IPersonaProps[] = sortedKeywords.map((keyword) => ({
                    text: keyword.name,
                    data: keyword,
                }));
                this.setState({ keywords, allowCustomKeywords: npcKeywordsResponse.allowCustom });
            }
        } catch (error) {
            this.props.logger.error("RfiReviewResponseComponent - load keywords error", error);

            if (ExpiredSessionError.isInstanceOf(error)) {
                this.props.onExpiredSession();
                return;
            }

            this.props.onShowToast(this.props.translate("SHARED.ERRORS.FAILED_LOADING_KEYWORDS") as string, "error");
        }
    }

    private onSubjectChange(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string): void {
        this.setState({ subject: newValue || "" });
    }

    private onReceivedDateChanged(date: Date | undefined): void {
        this.setState({ receivedDate: date });
    }

    private onFromChange(people: IPersonaProps[]): void {
        this.setState({ from: people });
    }

    private onToChange(people: IPersonaProps[]): void {
        this.setState({ to: people });
    }

    private onCcChange(people: IPersonaProps[]): void {
        this.setState({ cc: people });
    }

    private onActionComboChange(option?: IComboBoxOption | undefined): void {
        this.setState({ selectedAction: option?.key });
    }

    private onAttachmentsUpdated(files: AttachmentItem[]): void {
        this.setState({
            attachments: files,
        });
        document.querySelector(".rfiReviewResponseComponent")?.scrollTo({
            top: document.querySelector(".rfiReviewResponseComponent")?.scrollHeight,
            behavior: "auto",
        });
    }

    private onRemarksChange(newValue?: string): void {
        this.setState({ remarks: newValue || "" });
    }

    private onOldEditorRemarksChange(
        event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
        newValue?: string
    ): void {
        this.setState({ remarks: newValue || "" });
    }

    private onActionChange(option: DetailedKeyword | null): void {
        this.setState({ selectedActionKeyword: option });
    }

    private getKeywordPlaceholder(itemsCount: any, selectText: string): string {
        if (!this.state.selectedProject) {
            return this.props.translate("SHARED.KEYWORD_DROPDOWN.NO_PROJECT_SELECTED") as string;
        }

        if (this.state.isLoadingKeywords) {
            return this.props.translate("SHARED.KEYWORD_DROPDOWN.LOADING") as string;
        }

        if (!itemsCount || itemsCount <= 0) {
            return this.props.translate("SHARED.KEYWORD_DROPDOWN.NO_ITEMS") as string;
        }

        return selectText;
    }

    onRenderRfiNumbers(props: ITagWithNixEnabled, itemProps: ISuggestionItemProps<any>): JSX.Element {
        return <SuggestedItemWithSubtextComponent primaryText={props.name} subtext={(props as any).description} />;
    }

    async onRfisFiltered(filter: string, selectedItems?: ITagWithNixEnabled[]): Promise<ITagWithNixEnabled[]> {
        if (!this.state.rfis) {
            return [];
        }

        if (!filter) {
            return this.state.rfis;
        }

        return this.state.rfis.filter((x) => {
            return (
                x.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) ||
                (x as any).description.toLocaleLowerCase().includes(filter.toLocaleLowerCase())
            );
        });
    }

    private onRfiSelected(selectedItem?: ITagWithNixEnabled): ITagWithNixEnabled | null {
        if (!selectedItem) {
            this.setState({ selectedRfi: undefined, selectedKeywords: [] });
            return null;
        }

        if (!this.state.isCloudProject && !!this.state.selectedProject) {
            this.setState({ isLoadingRecipientEmail: true });
            this.props.rfiApiService
                .getRfiDetails(selectedItem.key as string, this.state.selectedProject.key as string)
                .then((rfiDetails) => {
                    const keywords = rfiDetails.keywords.map((keyword) => ({ text: keyword.name, data: keyword }));
                    const toEmails = rfiDetails.from?.email ? [{ text: rfiDetails.from.email }] : [];
                    this.setState({ selectedKeywords: keywords });
                    this.setState({
                        respondAndCloseEmailRecipients: {
                            to: toEmails,
                            from: [],
                        },
                    });
                    this.setState({ isLoadingRecipientEmail: false });
                })
                .catch((error) => {
                    this.handleApiError(error);
                });
        }

        this.setState({
            selectedRfi: {
                ...selectedItem,
                name: `${selectedItem.name} ${(selectedItem as any).description}`.trim(),
            },
        });

        return selectedItem;
    }

    private onRfiChange(items?: ITagWithNixEnabled[]): void {
        if (!items?.length) {
            this.setState({ selectedRfi: undefined, selectedKeywords: [] });
        }
    }

    private onKeywordsChanged(items: IPersonaProps[]): void {
        this.setState({ selectedKeywords: items });
    }

    private onEmptyRfiNumberInputFocus(selectedItems?: ITagWithNixEnabled[]): ITagWithNixEnabled[] {
        if (this.state.rfis) {
            return this.state.rfis;
        }

        return [];
    }

    private async onFormSubmit(): Promise<void> {
        this.props.logger.info("File Email as RFI Response form submitted");
        this.setState({ isFiling: true });
        let isRespondAndClose = false;
        const rfiKey = this.state.selectedRfi?.key;
        const selectedProject = this.state.selectedProject?.key;
        try {
            const messageNrn = this.props.officeWrapper.getCurrentMessageNrn();
            const rfiDetails = await this.props.rfiApiService.getRfiDetails(
                this.state.selectedRfi?.key as string,
                this.state.selectedProject?.key as string
            );

            const respondCloseReviewDate = this.state.respondAndCloseDate
                ? DateHelper.adjustTime(this.state.respondAndCloseDate)
                : null;

            const respondAndCloseAttachmentsFlag =
                this.state.attachments.length === 0 && this.state.respondAndCloseAttachments.length > 0 ? true : false;
            const respondCloseRfi: RespondCloseRfiRequest = {
                version: "0",
                via: "info-exchange",
                receivedDate: respondCloseReviewDate || undefined,
                response: this.state.respondAndCloseResponse?.trim() || null,
                to: this.props.formValidationHelpers.mapPersonaPropsToContact(
                    this.state.respondAndCloseEmailRecipients.to
                ),
                cc: this.state.respondAndCloseEmailRecipients.cc
                    ? this.props.formValidationHelpers.mapPersonaPropsToContact(
                          this.state.respondAndCloseEmailRecipients.cc
                      )
                    : [],
                from: this.props.formValidationHelpers.mapPersonaPropsToContact(this.state.from)[0],
                subject: this.state.isCloudProject ? undefined : this.state.subject,
                keywords: this.props.formValidationHelpers.mapPersonaPropsToKeywords(
                    this.state.respondAndCloseSelectedKeywords
                ),
                action: this.state.selectedAction ? this.state.selectedAction?.toString() : "",
                respondAndCloseAttachmentsOnly: respondAndCloseAttachmentsFlag,
            };

            isRespondAndClose = !!(
                respondCloseRfi &&
                this.props.isRfiRespondCloseSupported &&
                this.state.shouldRespondAndClose
            );

            const requestParams: RfiReviewResponseRequestParams = {
                from: this.props.formValidationHelpers.mapPersonaPropsToContact(this.state.from)[0],
                to: this.props.formValidationHelpers.mapPersonaPropsToContact(this.state.to),
                cc: this.state.cc.length
                    ? this.props.formValidationHelpers.mapPersonaPropsToContact(this.state.cc)
                    : undefined,
                action: this.state.isCloudProject
                    ? this.props.formValidationHelpers.mapDetailedKeywordToKeyword(
                          this.state.selectedActionKeyword as DetailedKeyword
                      )
                    : undefined,
                response: this.state.isCloudProject
                    ? this.state.remarks.trim()
                    : this.props.formValidationHelpers.mapDetailedKeywordToKeyword(
                          this.state.selectedActionKeyword as DetailedKeyword
                      ),
                keywords: !this.state.isCloudProject
                    ? this.props.formValidationHelpers.mapPersonaPropsToKeywords(this.state.selectedKeywords)
                    : undefined,
                remarks: !this.state.isCloudProject ? this.state.remarks : undefined,
                version: rfiDetails.version,
                subject: !this.state.isCloudProject ? (this.state.subject as string).trim() : undefined,
                receivedDate: this.state.isCloudProject
                    ? undefined
                    : this.props.dateHelpers.getNewDateAtStartOfDay(this.state.receivedDate as Date).toISOString(),
                via: this.state.isCloudProject ? undefined : { name: "Email", type: "transferMethod" },
                respondCloseRfiData:
                    this.props.isRfiRespondCloseSupported && this.state.shouldRespondAndClose
                        ? respondCloseRfi
                        : undefined,
            };

            await this.props.rfiApiService.logEmailAsRfiReviewResponse(
                this.state.selectedProject?.key as string,
                messageNrn,
                this.state.selectedRfi?.key as string,
                requestParams,
                this.state.attachments,
                this.fileUploadCallback.bind(this),
                this.props.isNL1221Supported,
                isRespondAndClose,
                this.state.respondAndCloseAttachments,
                this.props.culture
            );

            try {
                const projectAsAny = this.state.selectedProject as any;
                this.props.analyticsManager.recordSmartFilingEvents(
                    projectAsAny.suggestedProject,
                    projectAsAny.suggestionIndex
                );
                await this.props.smartFilingManager.addToFiledHistory(
                    this.state.selectedProject ?? { key: "", name: "" },
                    this.props.mailboxItem?.conversationId as string,
                    this.props.mailboxItem?.sender.emailAddress as string
                );
            } catch (error) {
                this.props.logger.error("RfiReviewResponseComponent - failed to update smart filing history", error);
            }

            this.shouldGoBackToRfiResponse();
            this.props.onShowToast(
                this.props.translate(
                    isRespondAndClose ? "RFI.RESPOND_CLOSE.SUCCESS_MESSAGE" : "RFI.RESPONSE.SUCCESS_MESSAGE"
                ) as string,
                "success"
            );
            this.setState({
                selectedRfi: undefined,
                selectedActionKeyword: null,
                selectedKeywords: [],
                shouldRespondAndClose: false,
                respondAndCloseAttachments: [],
            });
        } catch (error) {
            this.handleApiError(error, isRespondAndClose);
        } finally {
            this.setState({
                isFiling: false,
                fileUploadIsInProgress: false,
            });
        }
    }

    isFormValid(): boolean {
        const {
            selectedProject,
            selectedRfi,
            selectedActionKeyword,
            from,
            to,
            cc,
            isFiling,
            isLoadingProjects,
            isLoadingKeywords,
            actionKeywords,
            subject,
            receivedDate,
            isCloudProject,
        } = this.state;
        const isReviewResponseFormValid =
            !!selectedProject &&
            !!selectedRfi &&
            selectedActionKeyword !== null &&
            !!from.length &&
            !!to.length &&
            !!actionKeywords &&
            !isFiling &&
            !isLoadingProjects &&
            !isLoadingKeywords &&
            (isCloudProject ? true : !!subject) &&
            (isCloudProject ? true : !!receivedDate) &&
            this.props.formValidationHelpers.areAssigneesValid(from, true) &&
            this.props.formValidationHelpers.areAssigneesValid(to, true) &&
            this.props.formValidationHelpers.areAssigneesValid(cc, false) &&
            !this.state.areToAndCCSame;
        const isRespondCloseFormValid = !this.state.shouldShowRespondCloseOptions || this.state.isRespondCloseFormValid;
        return isReviewResponseFormValid && isRespondCloseFormValid;
    }

    private handleApiError(error: any, isRespondAndClose: boolean = false): void {
        this.props.logger.error("RfiReviewResponseComponent API error", error);

        this.shouldGoBackToRfiResponse();

        if (ExpiredSessionError.isInstanceOf(error)) {
            this.props.onExpiredSession();
            return;
        }

        if (error.level !== undefined && error.level === ApiRequestErrorLevel.WARNING) {
            this.props.onShowToast(this.props.translate(error.messageToDisplay) as string, "warning");
            return;
        }

        if (error.level !== undefined && error.level === ApiRequestErrorLevel.ERROR) {
            const failedAttachmentNames = this.state.failedUploadAttachmentNames;
            if (failedAttachmentNames.length) {
                const messageToDisplay = (this.props.translate(error.messageToDisplay) as string)
                    .replace("[[attachment-names]]", failedAttachmentNames.join("\n"))
                    .replace("[[failed-attachment-count]]", failedAttachmentNames.length.toString());
                this.props.onShowToast(messageToDisplay, "error");
                return;
            }
            this.props.onShowToast(this.props.translate(error.messageToDisplay) as string, "error");
            return;
        }

        if (error.level === undefined) {
            this.props.onShowToast(
                this.props.translate(
                    isRespondAndClose ? "RFI.RESPOND_CLOSE.FAILED_GENERIC" : "RFI.RESPONSE.FAILED_GENERIC"
                ) as string,
                "error"
            );
        }
    }

    fileUploadCallback(isInProgress: boolean, failedIds: string[]) {
        const failedAttachmentNames = !isInProgress ? this.getFailedAttachmentNames(failedIds) : [];
        this.setState({
            fileUploadIsInProgress: isInProgress,
            failedUploadAttachmentNames: failedAttachmentNames,
        });
    }

    private getFailedAttachmentNames(failedIds: string[]): string[] {
        return failedIds.length > 0
            ? this.state.attachments.filter((x) => failedIds.includes(x.id)).map((x) => x.name)
            : [];
    }

    private async refreshProjects(): Promise<void> {
        await this.props.invalidateCacheService.invalidateCache(ProjectsCacheKeys.rfisCacheName);
        return this.loadProjects();
    }

    private onCCAndToComparison(areToAndCCSame: boolean): void {
        this.setState({ areToAndCCSame });
    }

    private isRespondCloseDisabled = (): boolean => {
        const project = this.state.selectedProject;
        if (!project || project.nixEnabled) {
            return false;
        }
        return true;
    };

    moveToRespondClose() {
        this.setState({
            shouldShowRespondCloseOptions: true,
            emailRecipients: { to: this.state.to, from: this.state.from, cc: this.state.cc },
        });
    }

    goBackToRfiResponse() {
        this.setState({ shouldShowRespondCloseOptions: false });
    }

    onUpdateRespondCloseCheckbox() {
        const shouldRespond = !this.state.shouldRespondAndClose;
        this.setState({
            shouldRespondAndClose: shouldRespond,
            shouldDismissAttachmentErrors: !shouldRespond,
        });
        this.updateRespondAndCloseAttachments([]);
    }

    shouldGoBackToRfiResponse() {
        this.setState({ shouldShowRespondCloseOptions: false });
    }

    updateRespondAndCloseDate(date: Date | undefined): void {
        this.setState({ respondAndCloseDate: date });
    }

    updateRespondAndCloseKeywords(option: IPersonaProps[], keywords: IPersonaProps[]): void {
        this.setState({ respondAndCloseSelectedKeywords: option, respondAndCloseKeywords: keywords });
    }

    updateRespondAndCloseResponse(respondAndCloseResponse: string | undefined): void {
        this.setState({ respondAndCloseResponse });
    }

    updateRespondAndCloseAttachments(respondAndCloseAttachments: AttachmentItem[]): void {
        this.setState({ respondAndCloseAttachments });
    }

    updateRespondAndCloseEmailRecipients(emails: EmailRecipients): void {
        this.setState({ respondAndCloseEmailRecipients: emails });
    }

    onRespondAndCloseBackButtonClicked() {
        this.setState({ shouldClearRespondAndCloseValues: false });
    }

    private handleRespondAndCloseFormValidation = (isValid: boolean): void => {
        this.setState({ isRespondCloseFormValid: isValid });
    };

    updateKeywordsLoadingState(isLoadingPurposes: boolean): void {
        this.setState({ isLoadingPurposes });
    }

    updateProjectsToBeRendered(projects: ProjectITag[]) {
        this.setState({ projectsWithSuggestedToBeRendered: projects });
    }

    render(): JSX.Element {
        return (
            <>
                {this.state.shouldShowRespondCloseOptions && (
                    <Stack className="newforma-frozen-subheader">
                        <Separator className="custom-separator-bg" alignContent="start">
                            <div>{this.props.translate("RFI.RESPOND_CLOSE.HEADER_TEXT")}</div>
                        </Separator>
                    </Stack>
                )}
                <div className="rfiReviewResponseComponent">
                    <div className="newforma-form newforma-rfiReviewResponseForm">
                        {this.state.shouldShowRespondCloseOptions ? (
                            <RespondCloseRfi
                                shouldShowRfiResponse={this.shouldGoBackToRfiResponse.bind(this)}
                                logger={this.props.logger}
                                updateRespondAndCloseDate={this.updateRespondAndCloseDate.bind(this)}
                                respondAndCloseDate={this.state.respondAndCloseDate}
                                respondAndCloseSelectedKeyword={this.state.respondAndCloseSelectedKeywords}
                                respondAndCloseKeywords={this.state.respondAndCloseKeywords}
                                respondAndCloseResponse={this.state.respondAndCloseResponse}
                                updateRespondAndCloseResponse={this.updateRespondAndCloseResponse.bind(this)}
                                updateEmails={this.updateRespondAndCloseEmailRecipients.bind(this)}
                                priorEmails={this.state.respondAndCloseEmailRecipients}
                                isLoadingRecipientEmail={this.state.isLoadingRecipientEmail}
                                officeWrapper={this.props.officeWrapper}
                                formValidationHelpers={this.props.formValidationHelpers}
                                projectsService={this.props.projectsService}
                                mailboxItem={this.props.mailboxItem}
                                selectedProject={this.state.selectedProject}
                                selectedRfi={this.state.selectedRfi}
                                onExpiredSession={this.props.onExpiredSession}
                                onFormValidationChange={this.handleRespondAndCloseFormValidation}
                                isFiling={this.state.isFiling}
                                updateLoadingState={this.updateKeywordsLoadingState.bind(this)}
                                onShowToast={this.props.onShowToast}
                                updateKeywords={this.updateRespondAndCloseKeywords.bind(this)}
                                updateClearValue={this.onRespondAndCloseBackButtonClicked.bind(this)}
                                configService={this.props.configService}
                                RfiApiService={this.props.rfiApiService}
                                onEmailCheck={this.onCCAndToComparison.bind(this)}
                                nrnServiceWrapper={this.props.nrnServiceWrapper}
                                responseAttachmentItems={this.state.attachments}
                                respondAndCloseAttachments={this.state.respondAndCloseAttachments}
                                updateRespondAndCloseAttachments={this.updateRespondAndCloseAttachments.bind(this)}
                                onActionChange={this.onActionComboChange.bind(this)}
                                selectedAction={this.state.selectedAction}
                                isFilePathInAttachmentsSupported={this.props.isFilePathInAttachmentsSupported}
                            />
                        ) : (
                            <>
                                <SuggestedProjectPickerComponent
                                    logger={this.props.logger}
                                    className="newforma-formSpacing"
                                    projects={this.state.projects}
                                    onProjectSelected={this.onProjectSelected.bind(this)}
                                    disabled={this.state.isLoadingProjects || this.state.isFiling}
                                    smartFilingManager={this.props.smartFilingManager}
                                    isLoadingProjects={this.state.isLoadingProjects}
                                    mailboxItem={this.props.mailboxItem}
                                    onRefresh={this.refreshProjects.bind(this)}
                                    myProjects={this.state.projects}
                                    selectedProject={this.state.selectedProject}
                                    updateProjectsToBeRendered={this.updateProjectsToBeRendered.bind(this)}
                                    projectsToBeRendered={this.state.projectsWithSuggestedToBeRendered}
                                />
                                {!this.state.isCloudProject ? (
                                    <div>
                                        <Label required={true}>
                                            {this.props.translate("RFI.RESPONSE.RFI_SUBJECT_LABEL") as string}
                                        </Label>
                                        <TextField
                                            className="newforma-formSpacing"
                                            id="rfiReviewResponse-subject"
                                            value={this.state.subject}
                                            onChange={this.onSubjectChange.bind(this)}
                                            disabled={this.state.isFiling || this.state.isLoadingProjects}
                                            maxLength={256}
                                        />
                                    </div>
                                ) : null}
                                <LabelComponent
                                    text={this.props.translate("RFI.RESPONSE.RFI_NUMBER") as string}
                                    required={true}
                                />
                                <div onMouseDown={this.handleMouseDownRfis.bind(this)}>
                                    <TagPicker
                                        className={`newforma-rfiNumber newforma-formSpacing ${
                                            !this.state.selectedProject ||
                                            this.state.isLoadingKeywords ||
                                            !this.state.rfis?.length
                                                ? `disabledStyle`
                                                : ``
                                        }`}
                                        selectedItems={this.state.selectedRfi ? [this.state.selectedRfi] : []}
                                        pickerSuggestionsProps={{
                                            suggestionsHeaderText: this.props.translate(
                                                "RFI.RESPONSE.RFI_NUMBER_PICKER_HEADER"
                                            ) as string,
                                            noResultsFoundText: this.props.translate(
                                                "RFI.RESPONSE.RFI_NUMBER_NONE"
                                            ) as string,
                                        }}
                                        onRenderSuggestionsItem={this.onRenderRfiNumbers.bind(this)}
                                        disabled={
                                            !this.state.selectedProject ||
                                            this.state.isLoadingKeywords ||
                                            this.state.isFiling ||
                                            !this.state.rfis?.length
                                        }
                                        itemLimit={1}
                                        onResolveSuggestions={this.onRfisFiltered.bind(this)}
                                        onItemSelected={this.onRfiSelected.bind(this)}
                                        onChange={this.onRfiChange.bind(this)}
                                        pickerCalloutProps={{
                                            calloutWidth: 280,
                                            directionalHintFixed: true,
                                            preventDismissOnResize: true,
                                            ...(isIPhone() ? { preventDismissOnScroll: true } : {}),
                                        }}
                                        resolveDelay={300}
                                        inputProps={{
                                            placeholder: this.getKeywordPlaceholder(
                                                this.state.rfis?.length,
                                                this.props.translate("RFI.RESPONSE.RFI_NUMBER_PLACEHOLDER") as string
                                            ),
                                        }}
                                        onEmptyInputFocus={this.onEmptyRfiNumberInputFocus.bind(this)}
                                    />
                                </div>
                                <TranslatedDatePickerComponent
                                    date={this.state.receivedDate}
                                    label={this.props.translate("RFI.RESPONSE.RECEIVED_DATE_LABEL") as string}
                                    onDateChange={this.onReceivedDateChanged.bind(this)}
                                    className={`newforma-subReviewResponseReceivedDate newforma-formSpacing ${
                                        this.state.isCloudProject ? "newforma-none" : ""
                                    }`}
                                    disabled={this.state.isFiling || this.state.isCloudProject}
                                    required={!this.state.isCloudProject}
                                    showClearDateButton={false}
                                />
                                <KeywordsDropdown
                                    className="newforma-rfiActionDropdown newforma-formSpacing"
                                    id="rfiReviewResponse-actionDropdown"
                                    options={this.state.actionKeywords}
                                    label={this.props.translate("RFI.RESPONSE.RESPONSE_LABEL") as string}
                                    placeholder={this.props.translate("RFI.RESPONSE.RESPONSE_PLACEHOLDER") as string}
                                    disabled={
                                        !this.state.selectedProject ||
                                        this.state.isLoadingKeywords ||
                                        this.state.isFiling ||
                                        !this.state.actionKeywords.length
                                    }
                                    isLoading={this.state.isLoadingKeywords}
                                    isProjectSelected={!!this.state.selectedProject}
                                    required={true}
                                    onSelectionChange={this.onActionChange.bind(this)}
                                    selectFirstOption={false}
                                    selectedPurposeKey={
                                        this.state.selectedActionKeyword
                                            ? this.state.selectedActionKeyword.displayOrder
                                            : null
                                    }
                                />
                                <FromAndToComponent
                                    key="rfiReviewResponse"
                                    className={"newforma-formSpacing"}
                                    isFromRequired={true}
                                    isToRequired={true}
                                    isCcRequired={false}
                                    includeCc={true}
                                    officeWrapper={this.props.officeWrapper}
                                    disabled={this.state.isFiling}
                                    formValidationHelpers={this.props.formValidationHelpers}
                                    mailboxItem={this.props.mailboxItem}
                                    onFromChange={this.onFromChange.bind(this)}
                                    onToChange={this.onToChange.bind(this)}
                                    onCcChange={this.onCcChange.bind(this)}
                                    logger={this.props.logger}
                                    projectsService={this.props.projectsService}
                                    disableOnError={true}
                                    onError={this.props.onShowToast}
                                    project={this.state.selectedProject}
                                    shouldHideFrom={false}
                                    onEmailCheck={this.onCCAndToComparison.bind(this)}
                                    EmailRecipients={this.state.emailRecipients}
                                    isForwardInProgress={this.state.shouldRespondAndClose}
                                />
                                <Label required={false}>
                                    {this.props.translate("RFI.RESPONSE.REMARK_LABEL") as string}
                                </Label>
                                {this.props.isNL1221Supported ? (
                                    <HTMLEditor
                                        value={this.state.remarks}
                                        onRemarksUpdate={this.onRemarksChange.bind(this)}
                                        configService={this.props.configService}
                                        isFiling={this.state.isFiling}
                                    />
                                ) : (
                                    <TextField
                                        className="newforma-formSpacing"
                                        id="rfiReviewResponse-remarks"
                                        multiline
                                        resizable={true}
                                        value={this.state.remarks}
                                        onChange={this.onOldEditorRemarksChange.bind(this)}
                                        disabled={this.state.isFiling}
                                        rows={5}
                                        maxLength={65000}
                                    />
                                )}
                                {!this.state.isCloudProject ? (
                                    <ChipPickerComponent
                                        className="newforma-formSpacing newforma-submittalRevResponseKeywords"
                                        required={false}
                                        disabled={
                                            this.state.isFiling ||
                                            this.state.isLoadingKeywords ||
                                            !this.state.selectedProject
                                        }
                                        items={this.state.keywords}
                                        selectedItems={this.state.selectedKeywords}
                                        onSelectedItemsChanged={this.onKeywordsChanged.bind(this)}
                                        label={this.props.translate("SUBMITTALS.KEYWORDS_LABEL") as string}
                                        allowCustomInput={this.state.allowCustomKeywords}
                                    />
                                ) : null}
                                <AttachmentsComponent
                                    attachments={this.state.attachments}
                                    otherPageAttachments={this.state.respondAndCloseAttachments}
                                    disabled={this.state.isFiling}
                                    allowFileUploads={true}
                                    onAttachmentsUpdated={this.onAttachmentsUpdated.bind(this)}
                                    isCloudProject={this.state.isCloudProject}
                                    logger={this.props.logger}
                                    isFilePathInAttachmentsSupported={this.props.isFilePathInAttachmentsSupported}
                                    classNameForScroll=".rfiReviewResponseComponent"
                                    customErrors={{
                                        duplicateFile:
                                            this.props.isRfiRespondCloseSupported && this.state.shouldRespondAndClose
                                                ? String(this.props.translate("SHARED.ATTACHMENTS.DUPLICATE_NAME_RFI"))
                                                : String(this.props.translate("SHARED.ATTACHMENTS.DUPLICATE_NAME")),
                                        maximumFiles:
                                            this.props.isRfiRespondCloseSupported && this.state.shouldRespondAndClose
                                                ? String(this.props.translate("SHARED.ATTACHMENTS.MAXIMUM_FILES_RFI"))
                                                : String(this.props.translate("SHARED.ATTACHMENTS.MAXIMUM_FILES")),
                                    }}
                                    shouldDismissErrors={this.state.shouldDismissAttachmentErrors}
                                    onDismissErrorsHandled={() =>
                                        this.setState({ shouldDismissAttachmentErrors: false })
                                    }
                                />
                                {this.props.isRfiRespondCloseSupported ? (
                                    <ForwardCheckbox
                                        label={this.props.translate("RFI.RESPOND_CLOSE.RESPOND_AND_CLOSE") as string}
                                        subtext={
                                            this.props.translate(
                                                "RFI.RESPOND_CLOSE.RESPOND_AND_CLOSE_SUBTEXT"
                                            ) as string
                                        }
                                        shouldForward={this.onUpdateRespondCloseCheckbox.bind(this)}
                                        checked={this.state.shouldRespondAndClose}
                                        isFiling={this.state.isFiling || this.isRespondCloseDisabled()}
                                        showDisableMessage={this.isRespondCloseDisabled()}
                                        teachingBubbleText={
                                            (this.props.showRespondAndCloseRfiTeachingBubble && {
                                                headline: String(
                                                    this.props.translate(
                                                        "TEACHING_BUBBLES_v1.RESPOND_AND_CLOSE_RFI_BUBBLE.HEADLINE"
                                                    )
                                                ),
                                                paragraph: String(
                                                    this.props.translate(
                                                        "TEACHING_BUBBLES_v1.RESPOND_AND_CLOSE_RFI_BUBBLE.PARAGRAPH_MIDDLE"
                                                    )
                                                ),
                                            }) ||
                                            null
                                        }
                                        onDismissTeachingBubble={this.props.onDismissTeachingBubble}
                                        isRespondAndClose={true}
                                    />
                                ) : null}
                            </>
                        )}
                    </div>
                    {this.state.fileUploadIsInProgress ? (
                        <ProgressIndicator
                            label={this.props.translate("SHARED.FILE_UPLOAD_PROGRESS_LABEL") as string}
                            className="newforma-progressIndicator"
                            styles={{
                                itemName: ".ms-label",
                            }}
                        />
                    ) : null}
                </div>
                <div id="footer" className="newforma-footer">
                    <DefaultButton
                        className="newforma-footerButton"
                        id={
                            this.state.shouldRespondAndClose
                                ? this.state.shouldShowRespondCloseOptions
                                    ? "fileAsRfiReviewResponseSubmitButton"
                                    : "rfiReviewResponseContinueButton"
                                : "fileAsRfiReviewResponseButton"
                        }
                        primary={true}
                        disabled={!this.isFormValid()}
                        onClick={
                            this.state.shouldRespondAndClose
                                ? this.state.shouldShowRespondCloseOptions
                                    ? this.onFormSubmit.bind(this)
                                    : () => this.moveToRespondClose()
                                : this.onFormSubmit.bind(this)
                        }
                        text={(this.props.translate(
                            this.state.shouldShowRespondCloseOptions
                                ? "RFI.RESPOND_CLOSE.SUBMIT_BUTTON"
                                : this.state.shouldRespondAndClose
                                ? "RFI.RESPOND_CLOSE.CONTINUE_BUTTON"
                                : "RFI.RESPONSE.SUBMIT_BUTTON"
                        ) as string).toLocaleUpperCase()}
                    />
                </div>
            </>
        );
    }
}

export default withLocalize(RfiReviewResponseComponent);
